// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"oh13_2","withCheckbox":"oHgMfv","productWrapper":"MIyK7e","link":"lqKVk9"};